export const PLAYER_CONTROLS_SIGNALS = {
  restart: 'restart',
  play: 'play',
  pause: 'pause',
  stop: 'stop',
  jumpBackward: 'jumpBackward',
  jumpForward: 'jumpForward',
  jumpNext: 'jumpNext',
  scoresModal: 'scoresModal',
  bracketsModal: 'bracketsModal',
  feedbackModal: 'feedbackModal',
  showSubtitles: 'showSubtitles',
  hideSubtitles: 'hideSubtitles',
  seek: 'seek',
  restartControlsTimer: 'restartControlsTimer',
}

export const PLAYER_SIGNALS = {
  videoStart: 'videoStart',
  videoEnd: 'videoEnd',
  videoError: 'videoError',
  updateHeartbeat: 'updateHeartbeat',
  updateVideoAnalytics: 'updateVideoAnalytics',
  reportPlaybackEvent: 'reportPlaybackEvent',
  reportContentEvent: 'reportContentEvent',
}

export const PLAYBACK_SIGNALS = {
  ...PLAYER_CONTROLS_SIGNALS,
  ...PLAYER_SIGNALS,
}
